export default __webpack_public_path__ + "locales/pt-BR/FormFillingTipsDialog.json?hash=f6e76189e78912e7c4710f110d07de84";